import { Platform } from 'react-native';

/**
 * Custom font family names — use these constants in StyleSheet.create()
 * instead of raw strings to avoid typos.
 */
export const Fonts = {
  RobotoLight: 'Roboto-Light',
  AponaLohit: 'AponaLohit',
  MeQuran: 'me_quran',
  Scheherazade: 'Scheherazade',
  AlQalamQuranMajeed2: 'AlQalamQuranMajeed2',
  KFGQPC: 'KfgqpcHafsUthmanicScript',
  Quraniconstwo: 'Quraniconstwo',
  MDI: 'Material-Design-Icons',
  FA: 'FontAwesome',
} as const;

/**
 * Material Design Icons unicode characters.
 * Font: Material-Design-Icons.ttf
 */
export const MdiIcons = {
  search:       '\ue65f', // mdi-action-search
  sort:         '\ue71a', // mdi-content-sort
  menu:         '\ue8a1', // mdi-navigation-menu
  settings:     '\ue660', // mdi-action-settings
  close:        '\ue89c', // mdi-navigation-close
  arrowBack:    '\ue89a', // mdi-navigation-arrow-back
  filterList:   '\ue708', // mdi-content-filter-list
  phonelink:    '\ue7c7', // mdi-hardware-phonelink  (Look & Feel)
  translate:    '\ue688', // mdi-action-translate     (Translations)
  naturePeople: '\ue835', // mdi-image-nature-people  (Attributions)
  textSms:      '\ue6f8', // mdi-communication-textsms (Feedback)
  moreVert:     '\ue8a3', // mdi-navigation-more-vert
} as const;

/**
 * FontAwesome 4 unicode characters.
 * Font: FontAwesome (fontawesome-webfont.ttf)
 */
export const FaIcons = {
  headphones:   '\uf025', // fa-headphones
  retweet:      '\uf079', // fa-retweet  (repeat)
  backward:     '\uf04a', // fa-backward (previous track)
  stepBackward: '\uf048', // fa-step-backward (3 sec back)
  play:         '\uf04b', // fa-play
  pause:        '\uf04c', // fa-pause
  stepForward:  '\uf051', // fa-step-forward (3 sec fwd)
  forward:      '\uf04e', // fa-forward (next track)
  times:        '\uf00d', // fa-times (close ×)
  facebook:     '\uf09a', // fa-facebook
  twitter:      '\uf099', // fa-twitter
  instagram:    '\uf16d', // fa-instagram
  shareAlt:     '\uf1e0', // fa-share-alt
} as const;

/**
 * Unicode code points for Quraniconstwo icon glyphs.
 */
export const QuranIcons = {
  makkah:  '\ue604',
  madinah: '\ue605',
} as const;

/**
 * Unicode glyph used as the verse-end badge background.
 * Rendered with Scheherazade font at ~46px.
 */
export const AyatEndGlyph = '\u06DD'; // ۝  (ARABIC END OF AYAH)

const FONT_FACES = `
@font-face {
  font-family: 'Roboto-Light';
  src: local('Roboto-Light'), url('/fonts/Roboto-Light.ttf') format('truetype');
}
@font-face {
  font-family: 'AponaLohit';
  src: local('AponaLohit'), url('/fonts/AponaLohit.ttf') format('truetype');
}
@font-face {
  font-family: 'me_quran';
  font-style: normal;
  font-weight: 400;
  src: local('me_quran'), url('/fonts/me_quran.ttf') format('truetype');
}
@font-face {
  font-family: 'AlQalamQuranMajeed2';
  font-style: normal;
  font-weight: 400;
  src: local('AlQalamQuranMajeed2'), url('/fonts/AlQalamQuranMajeed2.ttf') format('truetype');
}
@font-face {
  font-family: 'KfgqpcHafsUthmanicScript';
  font-style: normal;
  font-weight: 400;
  src: local('KfgqpcHafsUthmanicScript'), url('/fonts/KfgqpcHafsUthmanicScriptRegular.ttf') format('truetype');
}
@font-face {
  font-family: 'Quraniconstwo';
  font-style: normal;
  font-weight: 400;
  src: local('Quraniconstwo'), url('/fonts/Quraniconstwo.ttf') format('truetype');
}
@font-face {
  font-family: 'Scheherazade';
  font-style: normal;
  font-weight: 400;
  src: local('Scheherazade'), url('/fonts/Scheherazade.ttf') format('truetype');
}
@font-face {
  font-family: 'Material-Design-Icons';
  src: url('/fonts/Material-Design-Icons.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'FontAwesome';
  src: url('/fonts/fontawesome-webfont.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
`;

let injected = false;

/**
 * Call once at app startup (web only).
 * Injects @font-face declarations so custom fonts resolve via fontFamily
 * in React Native Web StyleSheet styles.
 */
export function initFonts(): void {
  if (Platform.OS !== 'web' || injected) return;
  const style = document.createElement('style');
  style.id = 'gv-fonts';
  style.textContent = FONT_FACES;
  document.head.appendChild(style);
  injected = true;
}
